module.exports = __webpack_public_path__ + "4a849a9fad65f8543af9edc5426a5be9.MP3";